import { API } from '@aws-amplify/api';

function ServiceException(message) {
    this.message = message;
    this.name = 'ServiceException';
}

class BaseService {
    constructor(apiName, collectionPath) {
        this.apiName = apiName;
        this.collectionPath = collectionPath;
    }

    async fetchRecords(query) {
        if (typeof query === 'undefined') {
            query = {};
        }

        let path = this.collectionPath;

        if (typeof query.page !== 'undefined') {
            //query.offset = (query.page - 1) * query.limit;
            query.offset = query.page * query.limit;
            delete query.page;
        }

        let headers = {
            'Content-Type': 'application/json',
        };

        let options = {
            headers: headers,
            queryStringParameters: query,
            response: true,
        };

        return this.makeGetApiCall(this.apiName, path, options);
    }

    async fetch(recordId, responseGroup = 'large') {
        let path = [this.collectionPath, recordId].join('/');

        let query = { 'response-group': responseGroup };

        let options = {
            queryStringParameters: query,
            response: true,
        };

        return this.makeGetApiCall(this.apiName, path, options);
    }

    async add(payload) {
        let path = this.collectionPath;

        let headers = {
            'Content-Type': 'application/json',
        };

        let options = {
            body: payload,
            headers: headers,
            response: true,
        };

        let response = await this.makePostApiCall(this.apiName, path, options);

        if (response.headers.location) {
            return this.makeGetApiCall(
                this.apiName,
                response.headers.location,
                { headers: headers, response: true }
            );
        } else {
            return response;
        }
    }

    async update(recordId, payload) {
        let path = [this.collectionPath, recordId].join('/');

        let headers = {
            'Content-Type': 'application/json',
        };

        let options = {
            body: payload,
            headers: headers,
            response: true,
        };

        return this.makePutApiCall(this.apiName, path, options);
    }

    async patch(recordId, payload) {
        let path = [this.collectionPath, recordId].join('/');

        let headers = {
            'Content-Type': 'application/json',
        };

        let options = {
            body: payload,
            headers: headers,
            response: true,
        };

        return this.makePatchApiCall(this.apiName, path, options);
    }

    async deleteRecord(recordId) {
        let path = [this.collectionPath, recordId].join('/');

        let options = { response: true };

        return this.makeDeleteApiCall(this.apiName, path, options);
    }

    makeGetApiCall(apiName, path, options) {
        console.log(`making GET call to ${apiName} api with path: ${path}`);
        console.log('GET call otions', options);

        try {
            return API.get(apiName, path, options);
        } catch (e) {
            console.trace(e);
            throw new ServiceException(e.message);
        }
    }

    makePostApiCall(apiName, path, options) {
        console.log(`making POST call to ${apiName} api with path: ${path}`);
        console.log('POST call otions', options);

        try {
            return API.post(apiName, path, options);
        } catch (e) {
            console.trace(e);
            throw new ServiceException(e.message);
        }
    }

    async makePutApiCall(apiName, path, options) {
        console.log(`making PUT call to ${apiName} api with path: ${path}`);
        console.log('PUT call otions', options);

        try {
            return await API.put(apiName, path, options);
        } catch (e) {
            console.trace(e);
            throw new ServiceException(e.message);
        }
    }

    async makePatchApiCall(apiName, path, options) {
        console.log(`making PATCH call to ${apiName} api with path: ${path}`);
        console.log('PATCH call otions', options);

        try {
            return await API.patch(apiName, path, options);
        } catch (e) {
            console.trace(e);
            throw new ServiceException(e.message);
        }
    }

    makeDeleteApiCall(apiName, path, options) {
        console.log(`making DELETE call to ${apiName} api with path: ${path}`);
        console.log('DELETE call otions', options);

        try {
            return API.del(apiName, path, options);
        } catch (e) {
            console.trace(e);
            throw new ServiceException(e.message);
        }
    }
}

export default BaseService;
